/**
 * FAQ Accordion Web Components
 * Handles FAQ section accordion functionality with plus/minus icons
 */

customElements.define('faq-accordion', class extends HTMLElement {
  connectedCallback() {
    // Optional: Add any accordion-group level functionality here
    // Could be used for features like "close others when one opens"
  }
});

customElements.define('faq-item', class extends HTMLElement {
  connectedCallback() {
    const toggle = this.querySelector('[data-target="faq-item.toggle"]');
    const content = this.querySelector('[data-target="faq-item.content"]');

    if (toggle && content) {
      this.toggle = (expand = toggle.getAttribute('aria-expanded') !== 'true') => {
        toggle.setAttribute('aria-expanded', expand);
        this.setAttribute('data-expanded', expand);

        if (expand) {
          content.removeAttribute('inert');
        } else {
          content.setAttribute('inert', '');
        }
      };

      toggle.addEventListener('click', () => this.toggle());
    }
  }
});
